import { z } from "zod";
import { NOTIFICATION_KINDS } from "../enums.js";
import { isoTimestampSchema } from "./common.js";

export const notificationSchema = z.object({
  id: z.string(),
  kind: z.enum(NOTIFICATION_KINDS),
  title: z.string(),
  body: z.string(),
  link: z.string().nullable(),
  readAt: isoTimestampSchema.nullable(),
  createdAt: isoTimestampSchema,
});
export type Notification = z.infer<typeof notificationSchema>;

export const notificationsResponseSchema = z.object({
  notifications: z.array(notificationSchema),
  unread: z.number().int(),
});
export type NotificationsResponse = z.infer<typeof notificationsResponseSchema>;

export const notificationIdParamsSchema = z.object({ id: z.string().min(1) });
